import {
    createColumn,
    getCommonBodyCellPropsTradesPositions,
    getCommonHeadCellProps,
    getCommonFooterCellProps,
    getEcdStatusCellProps,
    renderEcdStatus,
    getEcdStatusSortPriority, // Add this import
  } from "./commonUtils";
  
  export const getEcdGenevaScrubColumns = (theme, globalFilter) => {
    const commonHeadCellProps = getCommonHeadCellProps(theme);
    const commonBodyCellProps = getCommonBodyCellPropsTradesPositions(theme);
    const commonFooterCellProps = getCommonFooterCellProps(theme);
    const ecdStatusCellProps = getEcdStatusCellProps(theme);
  
    const highlightMatch = (text, searchTerm) => {
      if (!searchTerm || !text) return text;
      const textStr = String(text);
      const searchStr = String(searchTerm);
      const regex = new RegExp(`(${searchStr})`, "gi");
      const parts = textStr.split(regex);
      return parts?.map((part, index) =>
        part.toLowerCase() === searchStr.toLowerCase() ? (
          <span
            key={index}
            style={{
              backgroundColor: theme.palette.warning.light,
              color: theme.palette.warning.contrastText,
              padding: "1px 2px",
              borderRadius: theme.shape.borderRadius * 0.5,
            }}
          >
            {part}
          </span>
        ) : (
          part
        ),
      );
    };
  
    // Helper function to format dates
    const formatDate = (dateValue) => {
      if (!dateValue || dateValue === "-") return "-";
      
      try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return dateValue; // Return original if invalid date
        
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
      } catch (error) {
        return dateValue; // Return original if parsing fails
      }
    };
  
    return [
      createColumn(
        commonHeadCellProps,
        commonBodyCellProps,
        commonFooterCellProps,
        "geneva_code",
        "Geneva Investment ID",
        "35%", // Changed from fixed width to percentage
        "left",
        {
          body: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          other: {
            enableGrouping: true,
            Cell: ({ cell }) =>
              highlightMatch(cell.getValue() || "-", globalFilter),
          },
        },
      ),
      createColumn(
        commonHeadCellProps,
        commonBodyCellProps,
        commonFooterCellProps,
        "geneva_ecd",
        "Geneva ECD Date",
        "25%", // Changed from fixed width to percentage
        "left",
        {
          body: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          other: {
            enableGrouping: true,
            Cell: ({ cell }) => {
              const formattedDate = formatDate(cell.getValue());
              return highlightMatch(formattedDate, globalFilter);
            },
          },
        },
      ),
      createColumn(
        commonHeadCellProps,
        commonBodyCellProps,
        commonFooterCellProps,
        "geneva_ecd_assigned",
        "Imported Geneva ECD Date",
        "25%", // Changed from fixed width to percentage
        "left",
        {
          body: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          other: {
            enableGrouping: true,
            Cell: ({ cell }) => {
              const formattedDate = formatDate(cell.getValue());
              return highlightMatch(formattedDate, globalFilter);
            },
          },
        },
      ),
      createColumn(
        commonHeadCellProps,
        ecdStatusCellProps, // Use the special ECD status cell props
        commonFooterCellProps,
        "geneva_ecd_flag",
        "ECD Status",
        "15%", // Changed from fixed width to percentage
        "center", // Center align the status column
        {
          body: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          other: {
            enableGrouping: true,
            // Add custom sorting function for Geneva ECD status
            sortingFn: (rowA, rowB, columnId) => {
              const a = rowA.getValue(columnId);
              const b = rowB.getValue(columnId);
              
              const priorityA = getEcdStatusSortPriority(a);
              const priorityB = getEcdStatusSortPriority(b);
              
              return priorityA - priorityB;
            },
            Cell: ({ cell }) => {
              const status = cell.getValue();
              if (!status || status === "-") return "-";
              
              // Use the renderEcdStatus utility for consistent styling
              return renderEcdStatus(status, theme);
            },
          },
        },
      ),
    ];
  };
  
  